import PosthogService from '~/services/posthog/PosthogService';
import { OnsiteInterviewStatus } from '~/domain/PermanentJobs/enums/OnsiteInterviewStatus';

// Event-specific interface (co-located)
export interface IPermInterviewListInterviewClickedPayload {
  postingId: string;
  interviewId: string;
  status: OnsiteInterviewStatus;
}

/**
 * Fires when user clicks on an interview in the interviews list
 * Event: dental_portal:perm_interview_list:interview_clicked
 */
export function firePermInterviewListInterviewClicked(
  payload: IPermInterviewListInterviewClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_interview_list:interview_clicked', {
    posting_id: payload.postingId,
    interview_id: payload.interviewId,
    status: payload.status,
  });
}
